export default __webpack_public_path__ + "static/media/bestdeals.31de5945.svg";